import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiAlertCircle, FiArrowLeft, FiCheckCircle, FiKey, FiMail, FiX } from 'react-icons/fi';
import authService from '../utils/auth.js';
import AuthShell from './AuthShell.jsx';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      if (!validateEmail(email)) {
        throw new Error('Please enter a valid email address');
      }

      await authService.forgotPassword(email);
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell>
      <div className="auth-card">
        <div className="auth-header">
          <span className="auth-icon" aria-hidden="true"><FiKey /></span>
          <h1>Forgot your password?</h1>
          <p>Enter your email and we&rsquo;ll send you reset instructions</p>
        </div>

        {error && (
          <div className="auth-alert auth-alert-error" role="alert">
            <FiAlertCircle className="auth-alert-icon" aria-hidden="true" />
            <span className="auth-alert-text">{error}</span>
            <button type="button" onClick={() => setError('')} className="auth-alert-close" aria-label="Dismiss"><FiX /></button>
          </div>
        )}

        {success ? (
          <div className="auth-result">
            <span className="auth-result-icon is-success" aria-hidden="true"><FiCheckCircle /></span>
            <div className="auth-alert auth-alert-success" role="status">
              <span className="auth-alert-text">Password reset instructions have been sent to your email.</span>
            </div>
            <div className="auth-links">
              <Link to="/login" className="auth-link"><FiArrowLeft aria-hidden="true" /> Return to login</Link>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="auth-form-group">
              <label htmlFor="email">Email address</label>
              <div className="auth-input">
                <FiMail aria-hidden="true" />
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoFocus
                  autoComplete="email"
                  placeholder="you@company.com"
                />
              </div>
            </div>
            <button type="submit" className="auth-button auth-button-primary" disabled={loading}>
              {loading && <span className="auth-spinner" aria-hidden="true" />}
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
            <div className="auth-links">
              <Link to="/login" className="auth-link"><FiArrowLeft aria-hidden="true" /> Back to login</Link>
            </div>
          </form>
        )}
      </div>
    </AuthShell>
  );
}

export default ForgotPassword;
